import {useAdmin} from "../../../contexts/AdminContext";
import React from "react";
import Heading from "../../../components/Heading";
import Text from "../../../components/Text";
import Button from "../../../components/Button";
import PaymentBox from "../PaymentBox";
import SubscriptionTable from "../SubscriptionTable";
import CompanyBox from "../CompanyBox";
import {useTranslation} from "react-i18next";
import {Subscription} from "../../../types/Subscription";
import cx from "classnames";
import styles from "./SubscriptionAdministration.module.css";
import CurrentSubscription from "../CurrentSubscription";
import Card from "../../../components/Card";
import {useGlobalContext} from "../../../contexts/globalContext";

const SubscriptionAdministration: React.FC<{changePage: (p: string) => void}> = ({changePage}) => {
    const { subscriptions, paymentMethods, getSubscription } = useAdmin()
    const {t} = useTranslation(['settings'])
    const { showToast } = useGlobalContext()

    return (
        <div className={cx(styles['container'], 'my-6')}>
            <div>
                <Heading level={3}>{t("subscription.welcome")}</Heading>
                <Text>
                    {t("subscription.completedSubs")}
                </Text>
                <SubscriptionTable subscriptions={subscriptions} changePage={changePage}/>
                {subscriptions.filter((s: Subscription) => s.host === window.location.host).length === 0
                    && <div className={'my-6'}>
                        <Heading level={3}>{t("subscription.bookNewLicense")}</Heading>
                        <div className={'d-flex flex-column justify-content-between'}>
                            <Text>
                                {paymentMethods.length === 0 ? t("subscription.bookNowMissingPayment") : t("subscription.bookNow")}
                            </Text>
                            <div className={cx(styles['button-container'])}>
                                <Button
                                    hierarchy={'primary'}
                                    text={t("subscription.bookNewLicense")}
                                    fn={() => changePage('subscribe')}
                                    disabled={paymentMethods.length === 0}
                                />
                            </div>
                        </div>
                    </div>
                }
                <Card
                    classes={'mt-4'}
                    title={t("subscription.currentSubscription")}
                    actions={[
                        {
                            title: t("subscription.syncWithServer"),
                            type: 'secondary',
                            onAction: () => {
                                getSubscription()
                                showToast('top-right', 'success', t("subscription.syncSuccess"))
                            },
                            classes: 'm-3 w-auto'
                        }]}
                >
                    <CurrentSubscription/>
                </Card>
            </div>
            <div>
                <CompanyBox className={'mb-6'} edit={() => changePage('change_company')}/>
                <PaymentBox/>
            </div>
        </div>
    )
}

export default SubscriptionAdministration
